import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/util/util.service';
import { CLOSE_TRANSPARENT } from 'src/defaultImages.js';
import { EventTrackerService } from '../../services/event-tracker.service';
import { LocalStorageService } from '../../services/localStorage.service';

@Component({
  selector: 'app-new-feature-ad',
  templateUrl: './new-feature-ad.component.html',
  styleUrls: ['./new-feature-ad.component.css'],
})
export class NewFeatureAdComponent implements OnInit {
  activeRoute: string;
  images = {
    CLOSE_TRANSPARENT: CLOSE_TRANSPARENT,
  };

  constructor(
    public _dialogRef: MatDialogRef<any>,
    private _local: LocalStorageService,
    private _router: Router,
    private _util : UtilService,
    private _eventTracker : EventTrackerService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.activeRoute = this._router.url;
    if (this.activeRoute === '/lock' || this.activeRoute === '/login') {
      this._dialogRef.close({
        status: 0,
        data: null,
        message: 'closed',
      });
    }
  }
  cancel() {
    this._local.set('ad_date', new Date().toISOString());
    this._eventTracker.easyeat_track_event('NEW_AD_VIEWED', {
      User_ID: this._util.getUserEmail(),
      HQ_ID: this._util.getHqId(),
      HQ_Name: this._util.getUserHqName(),
      User_HQ_Role: this._local.get('ee_user_type') || 'N/A',
    });
    this._dialogRef.close({
      status: 0,
      data: null,
      message: 'closed',
    });
  }
}
